import React from 'react';
import Meta from '../components/Meta';
import { OrganizationSchema, SoftwareApplicationSchema, WebSiteSchema } from '../components/StructuredData';
import HeroSection     from '../components/HeroSection';
import FeatureSection  from '../components/FeatureSection';
import ShowcaseSection from '../components/ShowcaseSection';
import FinalCTA        from '../components/FinalCTA';

const HomePage = () => {
  return (
    <>
      <Meta />
      <OrganizationSchema />
      <SoftwareApplicationSchema />
      <WebSiteSchema />

      <HeroSection />
      <FeatureSection />
      <ShowcaseSection />
      <FinalCTA />

      <div className="relative -mt-1">
        <svg
          className="block w-full"
          viewBox="0 0 1440 120"
          preserveAspectRatio="none"
        >
          <path
            d="M0 60c120 30 240 30 360 0s240-30 360 0 240 30 360 0 240-30 360 0v60H0Z"
            fill="#13C5C5"
          />
        </svg>
      </div>
    </>
  );
};

export default HomePage;
